import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import { displayCreationModal } from 'saas/contacts/modals';
import cx from 'classnames';
import { Form } from 'semantic-ui-react';
import Dropdown from 'common/components/Dropdown';
import { List } from 'immutable';

export class ContactSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contacts: List(props.contacts),
      selected: props.defaultSelected,
    };
    this._onAddContact = this._onAddContact.bind(this);
  }

  _onAddContact(evt) {
    evt.stopPropagation();
    evt.preventDefault();

    // Displaying contact modal
    displayCreationModal(this.props.customer, contact => {
      this.props.onAdded(contact.id);
      this.setState({
        selected: contact.id,
        contacts: this.state.contacts.push(contact),
      });
    });
  }

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  render() {
    const { errors } = this.props;
    const { contacts } = this.props;

    const hasError = (global = false) => {
      if (errors) {
        return errors.includes('contactIds');
      }
      return false;
    };

    const segmentClasses = cx('ui segment form', {
      error: hasError(),
    });

    const filteredContact = () => {
      return contacts.filter(
        c => c.is_usable_as_contact_site === true && c.is_deleted === false
      );
    };

    const renderDefault = () => (
      <div className="default text">Choisissez un contact</div>
    );

    const renderContact = contact => (
      <div key={contact.id} data-value={contact.id} className="item">
        {contact.last_name} {contact.first_name}
      </div>
    );

    const onChange = (contactId, _) => {
      this.props.onSelected(contactId);
      this.setState({
        selected: contactId,
      });
    };

    return (
      <div className={segmentClasses}>
        <h3 className="ui header">
          Choix du contact site
          <button
            className="ui right floated labeled icon button"
            onClick={this._onAddContact}
          >
            <i className="icon add" />
            Créer un nouveau contact
          </button>
        </h3>
        {hasError(true) && (
          <div className="ui error message">
            <p>Vous devez sélectionner un contact par site.</p>
          </div>
        )}
        <br />
        <Form.Field>
          <label>Contact site</label>
          <div className="fields">
            <div className="six wide field">
              <Dropdown
                name={`contact`}
                value={this.state.selected}
                items={filteredContact()}
                renderDefault={renderDefault}
                renderItem={renderContact}
                onChange={onChange}
              />
            </div>
          </div>
        </Form.Field>
      </div>
    );
  }
}

ContactSelector.propTypes = {
  customer: PropTypes.number.isRequired,
  contacts: PropTypes.array.isRequired,
  onAdded: PropTypes.func.isRequired,
  onSelected: PropTypes.func.isRequired,
  errors: PropTypes.array.isRequired,
  defaultSelected: PropTypes.number,
};

export default ContactSelector;



// WEBPACK FOOTER //
// ./src/modules/saas/sites/components/ContactSelector.js